import * as React from "react";
import type { SVGProps } from "react";
const SvgAlarm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#EE2049"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m13.335 13.882-1.507-1.507M4.172 12.375l-1.507 1.507M5.958 3.735a5.334 5.334 0 1 1 4.084 9.855 5.334 5.334 0 0 1-4.084-9.855M5 2.087a2.343 2.343 0 0 0-2.981 2.576M11 2.087a2.343 2.343 0 0 1 2.981 2.576M8 8.498V6.78"
    />
    <path
      stroke="#EE2049"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.085 10.466A.085.085 0 1 1 8 10.381M8 10.377c.047 0 .085.038.085.085"
    />
  </svg>
);
export default SvgAlarm;
